export const getSnackBarProps = ({ global }) => global.snackbar;
export const getSecSnackBarProps = ({ global }) => global.secondarySnackBar;
export const getMultiLineSnackBarProps = ({ global }) => global.multiLineSnackbar;


export const getTopRightInfo = ({ global }) => global.topRightInfo;

export const getBuildLoader = ({ global }) => global.buildLoader;
export const getDeployLoader = ({ global }) => global.deployLoader;

export const getSelctedTransactionId = ({ global }) => global.selectedTransactionId

export const getSelectedNode = ({ global }) => global.selectedNode;

export const getSelectedEvent = ({ global }) => global.eventToEdit;
export const getActiveLabel = ({ global }) => global.activeLabel;

export const getDfRenderCount = ({ global }) => global.dataFlowRenderCount;
export const getTVRenderCount = ({ global }) => global.treeViewRenderCount
export const getRenderCount = ({ global }) => global.renderCount;
export const getPsChangeDetector = ({ global }) => global.psChangeDetector;

export const getBlueprintDetails = ({ global }) => global.details;
export const getLeftDrawerStatus = ({ global }) => global.leftDrawerStatus;
export const getRightDrawerStatus = ({ global }) => global.rightDrawerStatus;
export const getBottomDrawerStatus = ({ global }) => global.bottomDrawerStatus;
export const getElementOnFocus = ({ global }) => global.elementOnFocus;
export const getBuildLogs = ({ global }) => global.logs;

export const getBottomTerminalInfo = ({ global }) => global.bottomTerminal;
export const getTabOnFocus = ({ global }) => global.tabOnFocus;
export const getForcedFocus = ({ global }) => global.isForcedFocus;

export const getElementToCopy = ({ global }) => global.elementToCopy;
export const getViewElementToCopy = ({ global }) => global.viewElementToCopy;

export const getTestcaseToCopy = ({ global }) => global.testcaseToCopy;

export const getTransactionState = ({ global }) => global.transactionState;
export const getTransactionDrawnState = ({ global }) => global.transactionDrawnState;
export const getTransactionToCreate = ({ global }) => global.transactionToCreate;
export const getHighlightNode = ({ global }) => global.highlightNode;
export const getBlueprintName = ({ global }) => global.details.title;
export const getSavingInProgress = ({ global }) => global.savingInProgress;
export const getNodeClicked = ({ global }) => global.nodeClicked;
export const getDisablePanStatus = ({ global }) => global.disableRfPan;
export const getlatestFieldAdded = ({ global }) => global.latestFieldAdded;
export const getBlueprintLoading = ({ global }) => global.isBlueprintLoading;
export const getCurrentTemplateTransaction = ({ global }) => global.currentTemplateTransaction;
export const getAppMode = ({ global }) => global.appMode;
export const getViewId = ({ global }) => global.currentViewId;
export const getAssetUpdated = ({ global }) => global.assetsUpdated;
export const getMenuAction = ({ global }) => global.menuAction;
export const getApiResponseCode = ({ global }) => parseInt(global.apiResponseCode);
export const getReRender = ({ global }) => global.reRender;
export const getInnerScreenRender = ({ global }) => global.innerScreenRender;
export const getApiResponseMessage = ({ global }) => global.apiResponseMessage;
export const getHeaderName = ({ global }) => global.drawerHeader;
export const getNestedTransactionEvents = ({ global }) => global.nestedTransactionEvents;
export const getNestedTransactionClusterlets = ({ global }) => global.nestedTransactionClusterlets;
export const getNestedTransactionChildren = ({ global }) => global.nestedTransactionChildren;
export const getNestedTransactionInvoked = ({ global }) => global.nestedTransactionInvoked;
export const getParentTransaction = ({ global }) => global.parentTransaction;
export const getDisabledStatus = ({ global }) => global.isDisabled;
export const getCodeEditStatus = ({ global }) => global.codeEditStatus;
export const getIsDocumentClicked = ({ global }) => global.isDocumentClicked;
export const getAddSimulationTransaction = ({ global }) => global.addSimulationTransaction;
export const getImageMapData = ({ global }) => global.imageMap;
export const getBottomTerminalStatus = ({ global }) => global.closeBottomTerminal;
export const getTransactionSelectorForSimulation = ({ global }) => global.toggleTransactionSelectorForSimulation;
export const getPaperReadyForTransactionStatus = ({ global }) => global.setPaperForTransactionInSimulation;
export const getNodeExpanded = ({ global }) => global.setNodeExpanded;
export const getBuildStatus = ({ global }) => global.buildStatus;
export const getTourDetails = ({global}) => global.UITour;
export const getTourConfig = ({global}) => global.UITour.config
export const getDialogScrolls = ({global}) => global?.dialogScrollLocations || []
export const getDashboardRefresh = ({ global }) => global.dashboardRefresh;
export const getUploadProgress = ({ global }) => global.uploads;
export const generatedLLMComponents = ({ global }) => global.llmComponents;  
export const showAcceptRejectButtons = ({ global }) => global.showAcceptRejectButton;
export const getLlmQuery = ({ global }) => global.llmQuery;
export const getLlmModel = ({ global }) => global.llmModel;
export const getValidationTrigger = ({ global }) => global.triggerBlueprintValidation;
export const getAiAssistant = ({ global }) => global.aiAssistant;
export const getAiAssistantLoading = ({ global }) => global.aiAssistant.loading;
export const getAiAssistantContext = ({ global }) => global.aiAssistant.requestContext;
export const getCollapsableSidebarStatus = ({ global }) => global.collapsableSidebarStatus;
export const getAIWidgetTransactionDetails = ({ global }) => global.aiWidgetTransaction;
export const getAiAssistantAutoProceed= ({ global }) => global.aiAssistant.autoProceed;
export const getLogHelpers = ({ global }) => global.logHelpers;
export const getSimulationRunStatus = ({ global }) => global.simulationRunning;
export const getValidatorStatus = ({ global }) => global.openValidator;
export const getOpenDeployment = ({ global }) => global.openDeployment;
export const getLogRedirectionData = ({ global }) => global.logRedirectionData